<b-modal :width="640" v-model="isActive">
	<b-notification type="is-primary" @close="isActive = false">
		<h2 class="title is-3">{{title}}</h2>
		<div class="content" v-html="text" />
	</b-notification>
</b-modal>
